import {
  PRODUCT_CREATE_REVIEW_FAIL,
  PRODUCT_CREATE_REVIEW_REQUEST,
  PRODUCT_CREATE_REVIEW_SUCCESS,
  PRODUCT_DETAILS_FAIL,
  PRODUCT_DETAILS_REQUEST,
  PRODUCT_DETAILS_SUCCESS,
  PRODUCT_LIST_FAIL,
  PRODUCT_LIST_REQUEST,
  PRODUCT_LIST_SUCCESS,
  PROMO_PRODUCTS_REQUEST,
  PROMO_PRODUCTS_SUCCESS,
  PROMO_PRODUCTS_FAIL,
} from "../Constants/ProductConstants";
import { logout } from "./userActions";
import URL from "../Url";

// PRODUCT LIST
export const listProducts = (keyword = "", pageNumber = "") => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_LIST_REQUEST });

    const res = await fetch(`${URL}/api/products?keyword=${keyword}&pageNumber=${pageNumber}`);
    const data = await res.json();
    if (!res.ok) throw new Error(data?.message || "Failed to fetch products");

    dispatch({ type: PRODUCT_LIST_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: PRODUCT_LIST_FAIL, payload: error.message });
  }
};

// SINGLE PRODUCT
export const listProductDetails = (id) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_DETAILS_REQUEST });

    const res = await fetch(`${URL}/api/products/${id}`);
    const data = await res.json();
    if (!res.ok) throw new Error(data?.message || "Failed to fetch product");

    dispatch({ type: PRODUCT_DETAILS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: PRODUCT_DETAILS_FAIL, payload: error.message });
  }
};

// PROMO PRODUCTS (featured + on sale)
export const listPromoProducts = () => async (dispatch) => {
  try {
    dispatch({ type: PROMO_PRODUCTS_REQUEST });

    const res = await fetch(`${URL}/api/products/promo`);
    const data = await res.json();
    if (!res.ok) throw new Error(data?.message || "Failed to fetch promo products");

    dispatch({ type: PROMO_PRODUCTS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: PROMO_PRODUCTS_FAIL, payload: error.message });
  }
};

// PRODUCT REVIEW CREATE
export const createProductReview = (productId, review) => async (dispatch, getState) => {
  try {
    dispatch({ type: PRODUCT_CREATE_REVIEW_REQUEST });

    const { userLogin: { userInfo } } = getState();

    const res = await fetch(`${URL}/api/products/${productId}/review`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
      body: JSON.stringify(review),
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data?.message || "Failed to submit review");

    dispatch({ type: PRODUCT_CREATE_REVIEW_SUCCESS });
  } catch (error) {
    if (error.message === "Not authorized, token failed") dispatch(logout());
    dispatch({ type: PRODUCT_CREATE_REVIEW_FAIL, payload: error.message });
  }
};